export default "__VITE_ASSET__b9061a01__"